/**
 * EAB Connect Help Center Article Template
 * 
 * This template provides a consistent structure for all Help Center articles.
 * Admins should use this template as a starting point when creating new articles.
 */

/**
 * Default HTML template for new Help Center articles
 * Follows EAB Connect's formal, clean documentation style
 */
export const HELP_ARTICLE_TEMPLATE = `<article class="help-article">
  <div class="help-article-intro">
    <p>Provide a brief introduction that explains what this article covers and who it's for.</p>
  </div>

  <h2>Section Title</h2>
  <p>Explain the main concept or feature here. Keep paragraphs short and focused on a single idea.</p>
  <p>Add additional details as needed. Use simple, direct language.</p>

  <h2>Key Points</h2>
  <ul>
    <li><strong>Point One:</strong> Describe the first key point</li>
    <li><strong>Point Two:</strong> Describe the second key point</li>
    <li><strong>Point Three:</strong> Describe the third key point</li>
  </ul>

  <h2>Step-by-Step Instructions</h2>
  <ol>
    <li>First step description</li>
    <li>Second step description</li>
    <li>Third step description</li>
  </ol>

  <div class="help-callout">
    <p><strong>Important:</strong> Add any critical notes or tips that users should be aware of.</p>
  </div>

  <h2>Related Information</h2>
  <p>Include any additional context or links to related articles.</p>

  <div class="help-footer-note">
    <p>Need more help? Contact support or visit the <a href="/help">Help Center</a> for additional resources.</p>
  </div>
</article>`;

/**
 * Minimal template for quick articles
 */
export const HELP_ARTICLE_TEMPLATE_MINIMAL = `<article class="help-article">
  <div class="help-article-intro">
    <p>Brief introduction to the topic.</p>
  </div>

  <h2>Overview</h2>
  <p>Main content goes here.</p>

  <h2>Key Points</h2>
  <ul>
    <li>First point</li>
    <li>Second point</li>
  </ul>
</article>`;

/**
 * Template placeholders for admin guidance
 * These are shown in the editor to guide admins on what to write
 */
export const TEMPLATE_GUIDANCE = {
  title: "Enter a clear, descriptive title (e.g., 'How to Request a Mentor Connection')",
  summary: "Write a one-sentence summary that appears in article listings",
  intro: "Provide a brief introduction explaining what this article covers",
  sectionTitle: "Use clear, action-oriented section headings",
  paragraph: "Keep paragraphs short and focused on a single idea",
  callout: "Use callouts for important notes, tips, or warnings",
};

/**
 * Allowed HTML tags for Help Center articles
 * These are safe for Lovable's HTML sanitization
 */
export const ALLOWED_TAGS = [
  'article',
  'div',
  'h2',
  'h3',
  'p',
  'ul',
  'ol',
  'li',
  'a',
  'strong',
  'em',
  'br',
];

/**
 * Allowed class names for styling
 */
export const ALLOWED_CLASSES = [
  'help-article',
  'help-article-intro',
  'help-callout',
  'help-footer-note',
];
